<template>
  <!-- FORM LOGIN BY PHONE -->
  <div class>
    <div class="phone-login">
      <form @submit.prevent="loginByPhone">
        <div class="form-group input-group-lg">
          <label for="inputHp">No HP</label>
          <input v-model="phone" type="input" class="form-control" id="inputHp" required="true" placeholder="No HP" />
        </div>
        <p class="text-center mt-5">
          <button type="submit" class="login-btn btn btn-primary bg-success text-white text-uppercase" style="border: none" >Login</button>
        </p>
        <div class="text-danger text-center">{{ error }}</div>
      </form>
    </div>
  </div>
  <!-- FORM LOGIN BY PHONE END-->
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data() {
    return {
      phone: ''
    };
  },
  methods: {
    ...mapActions('account', ['loginByPhoneAction']),
    loginByPhone() {
      this.loginByPhoneAction(this.phone)
    }
  },
  computed: {
    ...mapState('account', ['error'])
  }
}
</script>